/** Tipos da Condição de Pagamento */
export interface CondicaoPagamentoTipo {
    id: number;
    nome: string;
}

export const tipoAntecipado: CondicaoPagamentoTipo = {id: 1, nome: 'Antecipado'};
export const tipoAvista: CondicaoPagamentoTipo = {id: 2, nome: 'A Vista'};
export const tipoPrazo: CondicaoPagamentoTipo = {id: 3, nome: 'A Prazo'};
export const tipoBNDS: CondicaoPagamentoTipo = {id: 4, nome: 'BNDS'};
export const tipoCinquentaAntecipadoCinquentaEmbarque: CondicaoPagamentoTipo = {id: 5, nome: '50% Antecipado e 50% Embarque'};

export const tiposCondicoesPagamento: CondicaoPagamentoTipo[] = [
    tipoAntecipado,
    tipoAvista,
    tipoPrazo,
    tipoBNDS,
    tipoCinquentaAntecipadoCinquentaEmbarque
];

/** Verifica se o tipo da Condição de Pagamento informado é igual a Antencipado */
export function isTipoAntecipado(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoAntecipado.id;
}

/** Verifica se o tipo da Condição de Pagamento informado é igual a Avista */
export function isTipoAvista(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoAvista.id;
}

/** Verifica se o tipo da Condição de Pagamento informado é igual a Prazo */
export function isTipoPrazo(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoPrazo.id;
}

/** Verifica se o tipo da Condição de Pagamento informado é igual a BNDS */
export function isTipoBNDS(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoBNDS.id;
}


/** Verifica se o tipo da Condição de Pagamento informado é igual a CinquentaAntecipadoCinquentaEmbarque */
export function isTipoCinquentaAntecipadoCinquentaEmbarque(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoCinquentaAntecipadoCinquentaEmbarque.id;
}
